module.exports = function(app) {

    app.filter('specialStatus', function() {
        return function(code) {
            switch (code) {
                case '3': return 'Permanently Disabled';
                case 'F': return 'Full-Time Student';
                case 'M': return 'Full-Time Student-MNLOA';
                case 'N': return 'None';
                default: return 'None';
            }
        };
    });

};


